export const UPDATE_HTML_BODY_LOADED_STATUS = 'htmlOutputTypes/UPDATE_HTML_BODY_LOADED_STATUS';
export const UPDATE_HTML_BODY = 'htmlOutputTypes/UPDATE_HTML_BODY';
